import { AbstractControl } from '@angular/forms';

export function PrivacyValidator(control: AbstractControl) {
  if (control) {
    const secluded = control.get('secluded') as AbstractControl;
    const home = control.get('home') as AbstractControl;
    const neighbor = control.get('neighbor') as AbstractControl;
    const others = control.get('others') as AbstractControl;

    if (
      (secluded && secluded.value) ||
      (home && home.value) ||
      (neighbor && neighbor.value) ||
      (others && others.value)
    ) {
      return null;
    }
  }

  return { invalidPrivacy: true };
}
